import { UserBasedTicketBasketHoldsSerializer } from "@app-contexts/user/features/basket/data/types/basket";
import Repository from "@shared/services/api/abstracts/Repository";

export default class UserBasedTicketBasketHoldRepository extends Repository<UserBasedTicketBasketHoldsSerializer> {
  public readonly repositoryName = "UserBasedTicketBasketHoldRepository";

  public readonly endpoint = "api/user/tickets/baskets/holds/";
}
